import React, { useEffect, useState } from "react";
import { Table, Form, Card, Button, Row, Col, Typography, Tabs, Tooltip, Popconfirm, message, Spin, Modal, Input, Select, Space, DatePicker } from 'antd';
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import dayjs from "dayjs";  
import { useSelector } from "react-redux";
const { Title } = Typography;
const { Option } = Select;

const ScheduleClass = () => {

    const [loading, setLoading] = useState(true);
    const [allJobs, setAllJobs] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [jobName, setJobName] = useState('');
    const [allClasses, setAllClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState(null);
    const [jobDate, setJobDate] = useState(null);
    const [frequency, setFrequency] = useState(null);
    const security = useSelector((state) => state.data.items[0]);

    useEffect(() => {
        fetchScheduledJobs();
        fetchClasses();
    }, []);

    const fetchScheduledJobs = async () => {

        try {
            const apiService = new ApiService(
                `${BASE_URL}/get_scheduled_job`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall();
            setAllJobs(response);

        }
        catch (error) {

        } finally {
            setLoading(false);
        }

    }

    const fetchClasses = async () => {
        try {

            const apiService = new ApiService(
                `${BASE_URL}/ruby_class`,
                { 'Content-Type': 'application/json' },
                'GET'
            );

            const response = await apiService.makeCall();
            setAllClasses(response?.classes);
        }
        catch (error) {

        }
    }



    const handleCreate = () => {
        if(security?.system_settings?.schedule_job?.create===false){
                  message.error('You do not have permission to create ');
                  return;
                }

        setFrequency(null);
        setJobName(null);
        setSelectedClass(null);
        setJobDate(null);
       
        setModalVisible(true);
    }

    const handleSave = async () => {
        try {

            setLoading(true);
            
            const body = {
                schedule_param: {
                    hour: Number(jobDate),
                    min: 0,
                    frequency: frequency,
                    class_name: selectedClass,
                    
                }
            };

            const apiService = new ApiService(
                `${BASE_URL}/schedule_job`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
            );
            const response = await apiService.makeCall();
            message.success('Job scheduled successfully.');

        }
        catch (Error) {

        }
        finally {
            setModalVisible(false);
            setFrequency(null);
            setJobName(null);
            setSelectedClass(null);
            setJobDate(null);
            setLoading(false);
            fetchScheduledJobs();


        }
    }

    const handleCancel = () => {
        setModalVisible(false);
        setFrequency(null);
        setJobName(null);
        setSelectedClass(null);
        setJobDate(null);
    }

    const handleDelete = async (job) => {

          if(security?.system_settings?.schedule_job?.delete===false){
                  message.error('You do not have permission to delete ');
                  return;
                }

        try {
            const body={
                delete_param:{
                    jid:job.job_id,
                    class_name:job.class_name
                }
            }
            setLoading(true);
            const apiService = new ApiService(
                `${BASE_URL}/cancel_scheduled_job`,
                { 'Content-Type': 'application/json' },
                'DELETE',body
            );
            await apiService.makeCall();
            message.success('Job canceled successfully.');
        }
        catch (error) {
            const errorMessage = error && typeof error === 'object'
                ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to delete job due to an unknown error';
            message.error(errorMessage);
        }
        finally {
            setLoading(false);
            fetchScheduledJobs();
        }
    }


    const columns = [
      
        {
            title: 'Job Id',
            dataIndex: 'job_id',
            key: 'job_id',
        },
        {
            title: 'Class Name',
            dataIndex: 'class_name',
            key: 'class_name',
        },
        {
            title: 'Next Schedule Time',
            dataIndex: 'next_schedule_time',
            key: 'next_schedule_time',
            render:(text)=>dayjs(text).format("DD/MM/YYYY hh:mm A")
            
        },
        {
            title: 'Frequency',
            dataIndex: 'frequency',
            key: 'frequency',            
        },
        
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <Space size="middle">
                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Are you sure to cancel this job?"
                            onConfirm={() => handleDelete(record)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<DeleteOutlined />} type="link" danger></Button>
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
       
    ]


    return (
        <Spin spinning={loading} size="default" >
            <div>
                <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={4} style={{ marginTop: '10px' }}>All Scheduled Jobs</Title>
                    </Col>
                    <Col style={{ marginTop: '10px' }}>

                        <Button type="primary" style={{ marginRight: '10px' }} onClick={handleCreate}>
                            Schedule Class
                        </Button>

                    </Col>
                </Row>

                <Modal
                    visible={modalVisible}
                    title="Schedule Class"
                    onCancel={handleCancel}
                    onOk={handleSave}
                    zIndex={1002}   // higher than sidebar
                >
                    <div>

                        {/* <Row >
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Job Name</Typography.Text>
                                    <Input
                                        placeholder="Enter job name"
                                        value={jobName}
                                        onChange={(e) => {
                                            setJobName(e.target.value)
                                        }
                                        }
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>

                        </Row> */}

                        <Row >
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Select Class</Typography.Text>
                                    <Select
                                        placeholder="Select class"
                                        value={selectedClass}
                                        onChange={(e) => {
                                            setSelectedClass(e)
                                        }}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    >
                                        {allClasses?.map((cla) => (
                                            <Option key={cla.class_name} value={cla.class_name}>
                                                {cla.class_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Frequency</Typography.Text>
                                    <Select
                                        placeholder="Select frequency"
                                        value={frequency}
                                        onChange={(value) => setFrequency(value)}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    >
                                        <Option value="Daily">Daily</Option>
                                        <Option value="Weekly"> Weekly </Option>
                                        <Option value="Monthly"> Monthly </Option>
                                        <Option value="Yearly"> Yearly </Option>
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                        <Row>

                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Job Date</Typography.Text>
                                    <Select
                                        placeholder="preffered start time"
                                        onChange={(value) => setJobDate(value)}
                                        value={jobDate}
                                        style={{ width: '100%', marginBottom: '10px' }}>
                                        <Option value="">None</Option>
                                        <Option value="0">12:00 AM</Option>
                                        <Option value="1">1:00 AM</Option>
                                        <Option value="2">2:00 AM</Option>
                                        <Option value="3">3:00 AM</Option>
                                        <Option value="4">4:00 AM</Option>
                                        <Option value="5">5:00 AM</Option>
                                        <Option value="6">6:00 AM</Option>
                                        <Option value="7">7:00 AM</Option>
                                        <Option value="8">8:00 AM</Option>
                                        <Option value="9">9:00 AM</Option>
                                        <Option value="10">10:00 AM</Option>
                                        <Option value="11">11:00 AM</Option>
                                        <Option value="12">12:00 PM</Option>
                                        <Option value="13">1:00 PM</Option>
                                        <Option value="14">2:00 PM</Option>
                                        <Option value="15">3:00 PM</Option>
                                        <Option value="16">4:00 PM</Option>
                                        <Option value="17">5:00 PM</Option>
                                        <Option value="18">6:00 PM</Option>
                                        <Option value="19">7:00 PM</Option>
                                        <Option value="20:">8:00 PM</Option>
                                        <Option value="21">9:00 PM</Option>
                                        <Option value="22">10:00 PM</Option>
                                        <Option value="23">11:00 PM</Option>

                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </div>

                </Modal>


                <Table
                    columns={columns}
                    dataSource={allJobs}
                >

                </Table>

            </div>

        </Spin>
    );
}
export default ScheduleClass;